// CRITICAL: localStorage polyfill MUST run FIRST - before ANY imports
// Execute polyfill immediately in this file to ensure it runs before webpack processes other modules
(function() {
  'use strict';
  if (typeof process !== 'undefined' && process.versions && process.versions.node && typeof window !== 'undefined') {
    try {
      var stub = {
        _data: {},
        getItem: function(k) { return this._data[String(k)] || null; },
        setItem: function(k, v) { this._data[String(k)] = String(v); },
        removeItem: function(k) { delete this._data[String(k)]; },
        clear: function() { this._data = {}; },
        get length() { return Object.keys(this._data).length; },
        key: function(i) { var keys = Object.keys(this._data); return (i >= 0 && i < keys.length) ? keys[i] : null; }
      };
      if (!('localStorage' in window)) {
        Object.defineProperty(window, 'localStorage', { value: stub, writable: false, configurable: false, enumerable: true });
      } else {
        try {
          Object.defineProperty(window, 'localStorage', { get: function() { return stub; }, set: function() {}, configurable: false, enumerable: true });
        } catch(e) {}
      }
    } catch(e) {}
  }
})();

// Import polyfill modules for additional coverage
import './setup/localStoragePolyfill.js';
import './polyfills/localStorage.js';

// Initialize Sentry first, before any other imports
import './config/sentry.js';
import * as Sentry from '@sentry/react';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={({ error, resetError }) => (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>Something went wrong</h2>
        <p>An error occurred in the application. Please try refreshing the page.</p>
        <button onClick={resetError}>Try again</button>
        <details style={{ marginTop: '20px', textAlign: 'left' }}>
          <summary>Error details</summary>
          <pre>{error.toString()}</pre>
        </details>
      </div>
    )} showDialog>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);